/**
 * Google Analytics 4 (GA4) loader.
 *
 * Bizim kendi self-hosted analytics'imizin YANINDA bedava ikinci bir veri
 * kaynağı olarak çalışır: ülke/şehir, demografi, geri dönen ziyaretçi ve
 * gerçek zamanlı raporlar GA4 panelinden (analytics.google.com) görülür.
 *
 * Measurement ID .env / Vercel ortam değişkeninden okunur; yoksa Firebase
 * projesine bağlı mevcut GA4 property'sine (REACT_APP_FIREBASE_MEASUREMENT_ID)
 * düşer. ID hiç yoksa sessizce devre dışı kalır.
 */

const GA4_ID =
  process.env.REACT_APP_GA4_MEASUREMENT_ID ||
  process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ||
  "";

let initialized = false;

export function initGA4() {
  if (initialized || !GA4_ID || typeof window === "undefined") return;
  initialized = true;

  // gtag.js yükleyici
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;

  gtag("js", new Date());
  gtag("config", GA4_ID, { send_page_view: true });
}

/**
 * GA4'e özel olay gönder (ör. randevu alındığında dönüşüm).
 * gtag yüklü değilse no-op.
 */
export function ga4Event(name, params = {}) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", name, params);
  }
}

export const GA4_ENABLED = !!GA4_ID;
